import Vue from 'vue'
import Router from 'vue-router'
import insurance from '@/components/views/insurance'
import serve from '@/components/views/serve'
import relation from '@/components/views/relation'
import client from '@/components/views/client'
import join from '@/components/views/join'
import news from '@/components/views/news'
import PrivacyPolicy from '@/components/views/PrivacyPolicy'

Vue.use(Router)
// 路由列表
const routerList = [
    {
      path: '/',
      name: 'insurance',
      component: insurance
    },
    {
      path: '/serve',
      name: 'serve',
      component: serve
    },
    {
      path: '/relation',
      name: 'relation',
      component: relation
    },
    {
      path: '/client',
      name: 'client',
      component: client
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
];

// 路由配置
const RouterConfig = {
    // mode: 'history',//去#
    routes: routerList
};

// 创建路由
const routers = new Router(RouterConfig)

// 路由拦截
routers.beforeEach((to, from, next) => {
    console.log(to, from, next)
    next()
})

routers.afterEach((to, from) => {
    console.log(to, from)
})

export default routers




// WEBPACK FOOTER //
// ./src/routers/index.js